import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from './modal';
import { authExpired, getLocalStorage,  } from './auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const contextPath = '/carsClass';
const queryName = 'CARS_CLASS';

export const useGetCarClassList = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_LIST`], 
                () => getCarsClassList(authInfo ? authInfo.accessToken:''),
                {
                    onError:(err)=> {console.log('useGetCarClassList',err);err.response.status===401 && authExpired(queryClient)}
                }
                );
}

const getCarsClassList = async (accessToken) => {
    const retVal = await instance.get(contextPath,{headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

    return retVal;
}

export const useGetCarClassDetail = (param) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_DETAIL`], 
                () => param ? getCarsClassDetail(param, authInfo ? authInfo.accessToken:'') : {},
                {
                    onError:(err)=> {console.log('useGetCarClassList',err);err.response.status===401 && authExpired(queryClient)}
                }
                );
}

const getCarsClassDetail = async (param, accessToken) => {
    const retVal = await instance.get(contextPath+'/'+param,{headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

    return retVal;
}

export const useSetCarsClass = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                case 'PUT':
                    return putCarsClass(sendParam, authInfo ? authInfo.accessToken:'');
                // case 'DELETE':
                //     return deleteClient(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putCarsClass(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_LIST`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putCarsClass = async (param, accessToken) => {

    const sendParam = {
        ccid: param.ccid,
        ccnm: param.ccnm,
        descr: param.descr,
    }

    const retVal = await instance.post(contextPath, sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useSetCars = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postCars(sendParam, authInfo ? authInfo.accessToken:'');
                case 'PUT':
                    return putCars(sendParam, authInfo ? authInfo.accessToken:'');
                // case 'DELETE':
                //     return deleteClient(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putCars(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_DETAIL`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postCars = async (param, accessToken) => {

    const sendParam = {
        ccid: param.ccid,
        car_idx:  param.car_idx,
        car_tm: param.car_tm,
        car_nm: param.car_nm,
        descr: param.descr,
    }

    const retVal = await instance.post(contextPath+'/cars', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putCars = async (param, accessToken) => {

    const sendParam = {
        cno: param.cno,
        car_idx:  param.car_idx,
        car_tm: param.car_tm,
        car_nm: param.car_nm,
        descr: param.descr,
    }

    const retVal = await instance.put(contextPath+'/cars', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useSetCounter = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postCounter(sendParam, authInfo ? authInfo.accessToken:'');
                case 'PUT':
                    return putCounter(sendParam, authInfo ? authInfo.accessToken:'');
                // case 'DELETE':
                //     return deleteClient(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putCounter(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_DETAIL`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postCounter = async (param, accessToken) => {

    const sendParam = {
        ccid: param.ccid,
        cnt_nm: param.cnt_nm,
    }

    const retVal = await instance.post(contextPath+'/counter', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putCounter = async (param, accessToken) => {

    const sendParam = {
        cnt_no: param.cnt_no,
        cnt_nm: param.cnt_nm,
    }

    const retVal = await instance.put(contextPath+'/counter', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useSetCounterKey = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'PUT':
                    return putCounterKey(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteCounterKey(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putCounterKey(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_DETAIL`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putCounterKey = async (param, accessToken) => {

    const sendParam = {
        kno: param.kno,
        code: param.code,
    }

    const retVal = await instance.put(contextPath+'/counterKey', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteCounterKey = async (param, accessToken) => {

    const retVal = await instance.delete(contextPath+'/counterKey/'+param.cnt_no, {headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

